import React from 'react';
import './Footer.css';

const footerLinks = [
  {
    heading: 'LetsCodeBrain',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Our Team', to: '/team' },
      { label: 'Careers', to: '/careers' },
      { label: 'Press', to: '/press' },
    ],
  },
  {
    heading: 'Courses',
    links: [
      { label: 'Web Development', to: '/courses/web-development' },
      { label: 'Data Science', to: '/courses/data-science' },
      { label: 'Digital Marketing', to: '/courses/digital-marketing' },
      { label: 'UX/UI Design', to: '/courses/ux-ui-design' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Blog', to: '/blog' },
      { label: 'Tutorials', to: '/tutorials' },
      { label: 'Free Guides', to: '/guides' },
      { label: 'Webinars', to: '/webinars' },
    ],
  },
  {
    heading: 'Contact',
    links: [
      { label: 'Help Center', to: '/help' },
      { label: 'Contact Us', to: '/contact' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Support', to: '/support' },
    ],
  },
];

const Footer = () => (
  <div>
    <footer className="footer minimal-footer">
      <div className="footer-main">
        <div className="footer-grid">
          {footerLinks.map((col, idx) => (
            <div className="footer-section" key={col.heading}>
              <h3>{col.heading}</h3>
              <ul>
                {col.links.map(link => (
                  <li key={link.label}>
                    <a href={link.to}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
    <div className="footer-bottom-bar">
      <div className="footer-bottom-content">
        <span className="footer-copyright">© 2025 LetsCodeBrain. All rights reserved.</span>
        <span className="footer-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-use">Terms of Use</a>
        </span>
      </div>
    </div>
  </div>
);

export default Footer; 